import type {ReferralExternalAction} from 'src/action-creators/referral-external';
import type {
  Question,
  Brand,
  QuestionApiError,
  JobResponse,
  JobDescription,
} from 'src/types/referral-external';

import {DEFAULT_BUTTON_COLOR} from 'src/utils/referral-external';
import {
  RECEIVE_QUESTIONS,
  RECEIVE_QUESTIONS_ERROR,
  RECEIVE_BRAND,
  FETCHING_REFERRAL_JOBS,
  FETCHING_LOCATIONS,
  FETCHING_DESCRIPTION,
} from 'src/action-creators/referral-external';


export type State = {
  questions: Question[];
  brand: Brand;
  // jobs: Job[],
  must_acknowledge_terms: boolean;
  program_name: string;
  welcome_message: string;
  customer_type: string;
  is_tracking_enabled: boolean;
  track_referral_by_email: boolean;
  is_referrer_portal_enabled: boolean;
  job_list_enabled: boolean;
  questionnaire_api_error: QuestionApiError | null | undefined;
  locations: string[] | null | undefined;
  jobs: JobResponse[] | null | undefined;
  jobDescription: JobDescription | null | undefined;
};

const initialState = {
  questions: [],
  brand: {logo_url: '', display_name: '', button_color: DEFAULT_BUTTON_COLOR},
  // jobs: [],
  must_acknowledge_terms: false,
  program_name: '',
  welcome_message: '',
  customer_type: '',
  is_tracking_enabled: true,
  track_referral_by_email: false,
  is_referrer_portal_enabled: false,
  job_list_enabled: false,
  questionnaire_api_error: null,
  locations: null,
  jobs: null,
  jobDescription: null,
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly questions: readonly []; readonly brand: { readonly logo_url: ""; readonly display_name: ""; readonly button_color: "#5c34cd"; }; readonly must_acknowledge_terms: false; readonly program_name: ""; ... 9 more ...; readonly jobDescription: null; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: ReferralExternalAction,
): State => {
  switch (action.type) {
    case RECEIVE_QUESTIONS: {
      // @ts-expect-error - TS2322 - Type '{ questions: Question[]; must_acknowledge_terms: boolean; program_name: string; welcome_message: string; customer_type: string; is_tracking_enabled: boolean; track_referral_by_email: boolean; ... 6 more ...; jobDescription?: JobDescription | null | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        questions: action.payload.questions,
        must_acknowledge_terms: action.payload.must_acknowledge_terms,
        program_name: action.payload.program_name,
        welcome_message: action.payload.welcome_message,
        customer_type: action.payload.customer_type,
        is_tracking_enabled: action.payload.is_tracking_enabled,
        track_referral_by_email: action.payload.track_referral_by_email,
        is_referrer_portal_enabled: action.payload.is_referrer_portal_enabled,
        job_list_enabled: action.payload.job_list_enabled,
      };
    }
    case RECEIVE_QUESTIONS_ERROR: {
      // @ts-expect-error - TS2322 - Type '{ questionnaire_api_error: QuestionApiError | null | undefined; questions?: Question[] | undefined; brand?: Brand | undefined; must_acknowledge_terms?: boolean | undefined; ... 9 more ...; jobDescription?: JobDescription | null | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        questionnaire_api_error: action.payload,
      };
    }
    case RECEIVE_BRAND: {
      // @ts-expect-error - TS2322 - Type '{ brand: { button_color: string; logo_url: string; display_name: string; }; questions?: Question[] | undefined; must_acknowledge_terms?: boolean | undefined; program_name?: string | undefined; ... 9 more ...; jobDescription?: JobDescription | null | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        brand: {
          ...action.payload,
          button_color: action.payload.button_color || DEFAULT_BUTTON_COLOR,
        },
      };
    }
    // case RECEIVE_JOBS: {
    //   return {
    //     ...state,
    //     jobs: action.payload,
    //   };
    // }
    case FETCHING_REFERRAL_JOBS: {
      // @ts-expect-error - TS2322 - Type '{ jobs: JobResponse[]; questions?: Question[] | undefined; brand?: Brand | undefined; must_acknowledge_terms?: boolean | undefined; program_name?: string | undefined; ... 8 more ...; jobDescription?: JobDescription | null | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        jobs: action.payload,
      };
    }
    case FETCHING_LOCATIONS: {
      // @ts-expect-error - TS2322 - Type '{ locations: string[]; questions?: Question[] | undefined; brand?: Brand | undefined; must_acknowledge_terms?: boolean | undefined; program_name?: string | undefined; ... 8 more ...; jobDescription?: JobDescription | null | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        locations: action.payload,
      };
    }
    case FETCHING_DESCRIPTION: {
      // @ts-expect-error - TS2322 - Type '{ jobDescription: JobDescription; questions?: Question[] | undefined; brand?: Brand | undefined; must_acknowledge_terms?: boolean | undefined; program_name?: string | undefined; ... 8 more ...; jobs?: JobResponse[] | null | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        jobDescription: action.payload,
      };
    }
  }
  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
};
